// services/budgetApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiReportsResponse } from '../../types/reports';
import { SkillData, SkillDetailsData } from '../../types/skills';
import { baseQueryWithReauth } from './baseQuery';

export const skillsRequestsService = createApi({
  reducerPath: 'skillsRequestsService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SkillsRequests'],
  endpoints: (builder) => ({
    getSkills: builder.query<ApiReportsResponse<SkillData>, string>({
      query: (params) => ({
        url: `/v1/skills-operator/requests?${params}`,
      }),
      providesTags: ['SkillsRequests'],
    }),
    getSkillById: builder.query<SkillDetailsData, number>({
      query: (id) => ({
        url: `/v1/skills-operator/requests/${id}`,
      }),
    }),
    rejectSkill: builder.mutation({
      query: (id) => ({
        url: `/v1/skills-operator/requests/${id}/reject`,
        method: 'PUT',
      }),
      invalidatesTags: ['SkillsRequests'],
    }),
    approveSkill: builder.mutation({
      query: (data) => ({
        url: `/v1/skills-operator/requests/approve`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['SkillsRequests'],
    }),
  }),
});

export const {
  useGetSkillsQuery,
  useGetSkillByIdQuery,
  useRejectSkillMutation,
  useApproveSkillMutation,
} = skillsRequestsService;
